import { Component, input, booleanAttribute } from '@angular/core';
import { HlmSpinnerImports } from '@pagai-fe/ui';

/**
 * Global loader component
 * Displays a full-screen overlay with spinner when loading
 */
@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [HlmSpinnerImports],
  templateUrl: './loader.component.html',
})
export class LoaderComponent {
  /** Loading state input */
  readonly isLoading = input(false, { transform: booleanAttribute });
}
